import { render, staticRenderFns } from "./flow_approve.vue?vue&type=template&id=2d2e1625&scoped=true"
import script from "./flow_approve.vue?vue&type=script&lang=js"
export * from "./flow_approve.vue?vue&type=script&lang=js"
import style0 from "./flow_approve.vue?vue&type=style&index=0&id=2d2e1625&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2e1625",
  null
  
)

export default component.exports